<template>
  <div :class="fieldStyling">
    <div class="ml-1 mt-2">
      <input
        :id="field.attributes.slug"
        v-model="value"
        type="checkbox"
        :name="field.attributes.slug"
        :class="{ 'error': errors.length }"
        :disabled="isDisabled"
        :aria-disabled="isDisabled"
      >
      <label
        class="field__label__text block mb-2"
        :for="field.attributes.slug"
        v-text="field.attributes.label"
      />
      <ErrorMessage
        v-if="errors"
        :error="errorMessage"
      />
    </div>
    <HelpText
      v-if="field.attributes.help"
      class="mt-6"
      :help-text="field.attributes.help"
    />
  </div>
</template>

<script type="text/babel">
import HelpText from './HelpText'
import ErrorMessage from './ErrorMessage'
import inputField from 'FormBuilder/Resources/assets/js/mixins/input-field.js'

export default {
  name: 'CheckboxField',
  components: {
    HelpText,
    ErrorMessage,
  },
  mixins: [inputField],
  mounted() {
    this.$emit('inputChanged', {
      field: this.field.attributes.slug,
      value: false,
    })
  },
}
</script>
